function getHeights(element: Element | null): {
  fixed: number
  scrolling: number
} {
  if (!(element instanceof HTMLElement)) {
    return {
      fixed: 0,
      scrolling: 0
    }
  }

  const isFixed = window.getComputedStyle(element).position === 'fixed'
  return isFixed
    ? {
        fixed: element.offsetHeight,
        scrolling: 0
      }
    : {
        fixed: 0,
        scrolling: element.offsetHeight
      }
}

function update() {
  const offset = { fixed: 0, scrolling: 0 }
  for (const id of ['primarynav', 'wpadminbar']) {
    const { fixed, scrolling } = getHeights(document.getElementById(id))
    offset.fixed += fixed
    offset.scrolling += scrolling
  }

  document.body.style.setProperty(
    '--header-height',
    offset.fixed + offset.scrolling + 'px'
  )
  document.body.style.setProperty('--header-height-fixed', offset.fixed + 'px')
  document.body.style.setProperty(
    '--header-height-scrolling',
    offset.scrolling + 'px'
  )
}

window.addEventListener('resize', update)
update()
